var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "show-right" }, [
        _c(
          "div",
          {
            staticClass: "main-content left",
            staticStyle: { "margin-top": "20px", "margin-left": "30px" }
          },
          [
            _c(
              "div",
              [
                _vm.readonly
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "1" },
                        on: {
                          click: function($event) {
                            return _vm.edit()
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("common.btn.edit")) + " ")]
                    )
                  : _vm._e(),
                !_vm.readonly
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "2" },
                        on: {
                          click: function($event) {
                            return _vm.cancel()
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("common.btn.cancel")) + " ")]
                    )
                  : _vm._e(),
                !_vm.readonly
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { type: "primary", no: "3" },
                        on: {
                          click: function($event) {
                            return _vm.saveOcrTemplate()
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("common.btn.save")) + " ")]
                    )
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { width: "100%" } },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { "margin-top": "20px" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-position": "right",
                      "label-width": "140px"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "CargoMsg.Cargo_TemplateIdAutomaticallyGenerated"
                          )
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.ocrTemplate.uuid) + " ")]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_TemplateStatus")
                        }
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.ocrTemplate.active,
                              callback: function($$v) {
                                _vm.$set(_vm.ocrTemplate, "active", $$v)
                              },
                              expression: "ocrTemplate.active"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Valid")))
                            ]),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Invalid2")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_IdentifyTemplateName2")
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "580px" },
                          attrs: { no: "templateName" },
                          model: {
                            value: _vm.ocrTemplate.templateName,
                            callback: function($$v) {
                              _vm.$set(_vm.ocrTemplate, "templateName", $$v)
                            },
                            expression: "ocrTemplate.templateName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "CargoMsg.Cargo_DocumentTypeDescription2"
                          )
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { height: "300px", width: "580px" },
                          attrs: {
                            "filter-chars": false,
                            no: "fileTypeDescription",
                            type: "textarea",
                            rows: 17,
                            maxlength: "2000"
                          },
                          model: {
                            value: _vm.ocrTemplate.fileTypeDescription,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.ocrTemplate,
                                "fileTypeDescription",
                                $$v
                              )
                            },
                            expression: "ocrTemplate.fileTypeDescription"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "margin-top": "15px" },
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_OutputRequirements")
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { height: "300px", width: "580px" },
                          attrs: {
                            "filter-chars": false,
                            no: "outputRequirements",
                            type: "textarea",
                            rows: 17,
                            maxlength: "2000"
                          },
                          model: {
                            value: _vm.ocrTemplate.outputRequirements,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.ocrTemplate,
                                "outputRequirements",
                                $$v
                              )
                            },
                            expression: "ocrTemplate.outputRequirements"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _c("div", {
          staticClass: "division",
          staticStyle: { "margin-left": "50px" }
        }),
        _c("div", { staticClass: "right" }, [
          _c(
            "div",
            { staticStyle: { "margin-top": "20px", "margin-left": "30px" } },
            [
              _c(
                "div",
                [
                  _c("span", { staticStyle: { "font-size": "18px" } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ReadField")))
                  ]),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", no: "view" },
                      on: {
                        click: function($event) {
                          return _vm.lookTemplateField()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_View")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: {
                        type: "primary",
                        disabled: _vm.ocrTemplateFieldDisabled,
                        no: "4"
                      },
                      on: {
                        click: function($event) {
                          return _vm.addTemplateField()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("SeaExport.Add")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        type: "primary",
                        disabled: _vm.ocrTemplateFieldDisabled,
                        no: "5"
                      },
                      on: {
                        click: function($event) {
                          return _vm.editTemplateField()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("SeaExport.Edit")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        type: "danger",
                        disabled: _vm.ocrTemplateFieldDisabled,
                        no: "6"
                      },
                      on: {
                        click: function($event) {
                          return _vm.deleteTemplateField()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("SeaExport.Delete")) + " ")]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { width: "600px", "margin-top": "30px" } },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: {
                      width: "100%",
                      height: "400px",
                      "margin-top": "10px"
                    },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        ])
      ]),
      _c("div", [
        _c(
          "div",
          { staticStyle: { display: "inline-block" } },
          [
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "670px" },
                attrs: { type: "primary", no: "7" },
                on: {
                  click: function($event) {
                    return _vm.previewPromptWord()
                  }
                }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("CargoMsg.Cargo_PreviewPromptWords")) +
                    " "
                )
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { display: "inline-block" } },
          [
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "60px" },
                attrs: { type: "primary", no: "8" },
                on: {
                  click: function($event) {
                    return _vm.goBack()
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_Back")) + " ")]
            )
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.ocrTemplateFieldDialog.visible,
            title: _vm.ocrTemplateFieldDialog.title,
            width: "700px",
            height: "950px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.ocrTemplateFieldDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "110px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_FieldName") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "540px" },
                        attrs: {
                          disabled: _vm.ocrTemplateFieldDialog.look,
                          no: "fieldName"
                        },
                        model: {
                          value: _vm.ocrTemplateFieldDialog.form.fieldName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.ocrTemplateFieldDialog.form,
                              "fieldName",
                              $$v
                            )
                          },
                          expression: "ocrTemplateFieldDialog.form.fieldName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_FieldRuleDescription")
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "540px" },
                        attrs: {
                          disabled: _vm.ocrTemplateFieldDialog.look,
                          "filter-chars": false,
                          no: "fieldRuleDescription",
                          type: "textarea",
                          rows: 21,
                          maxlength: "2000"
                        },
                        model: {
                          value:
                            _vm.ocrTemplateFieldDialog.form
                              .fieldRuleDescription,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.ocrTemplateFieldDialog.form,
                              "fieldRuleDescription",
                              $$v
                            )
                          },
                          expression:
                            "ocrTemplateFieldDialog.form.fieldRuleDescription"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.ocrTemplateFieldDialog.look,
                      expression: "!ocrTemplateFieldDialog.look"
                    }
                  ],
                  attrs: {
                    type: "primary",
                    no: "7",
                    disabled: _vm.ocrTemplateFieldDialog.look
                  },
                  on: { click: _vm.saveOcrTemplateField }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.ocrTemplateFieldDialog.look,
                      expression: "!ocrTemplateFieldDialog.look"
                    }
                  ],
                  attrs: { no: "8" },
                  on: {
                    click: function($event) {
                      _vm.ocrTemplateFieldDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.ocrTemplateFieldDialog.look,
                      expression: "ocrTemplateFieldDialog.look"
                    }
                  ],
                  attrs: { no: "8" },
                  on: {
                    click: function($event) {
                      _vm.ocrTemplateFieldDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Back")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.promptWordDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_PreviewPromptWords"),
            width: "700px",
            "close-on-click-modal": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.promptWordDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { staticStyle: { "margin-left": "50px" } },
                [
                  _c("el-form-item", [
                    _c("pre", {
                      staticStyle: {
                        "white-space": "pre-wrap",
                        "overflow-y": "auto",
                        "overflow-x": "hidden",
                        width: "600px",
                        height: "60vh",
                        "min-height": "300px"
                      },
                      domProps: {
                        innerHTML: _vm._s(_vm.promptWordDialog.promptWord)
                      }
                    })
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.promptWordDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }